module.exports = __webpack_public_path__ + "static/img/lt.68fa4a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lt.jpg
// module id = RrWo
// module chunks = 1